<ph-stack gap="tight">
    <ph-label *ngIf="section.label">{{ section.label }}</ph-label>
    <ph-facts *ngIf="facts as rows; else bodyAlert" size="small" value-align="end" [attr.items]="rows | json"></ph-facts>
    <ng-template #bodyAlert>
        <ph-alert [status]="section.tone === 'warning' ? 'warning' : 'information'" variant="lighter" size="small"><span class="body">{{ shownBody }}</span></ph-alert>
        <ph-link-button *ngIf="collapsible" variant="primary" size="small" (click)="showAll = !showAll">
            {{ showAll ? 'Show fewer' : 'Show all ' + lines.length }}
        </ph-link-button>
    </ng-template>
</ph-stack>
